import type { OriginalItemTypes } from "@memorang/types";

const PTE_ASSESSOR_SUPPORTED_CODES: ReadonlySet<OriginalItemTypes> = new Set([
	"WESW",
	"WEMSW_CORE",
	"SWTR",
	"SWTR_CORE",
	"SSTL",
	"SSTL_CORE",
	"RTSSW",
	"RTSSW_CORE",
	"RSSW",
	"RSSW_CORE",
	"RASW",
	"RASW_CORE",
	"SGDL",
	"RLSW",
	"DISW",
	"DISW_CORE",
	"ASQSW",
	"ASQSW_CORE",
]);

const PTE_ASSESSOR_SPEAKING_CODES: ReadonlySet<OriginalItemTypes> = new Set([
	"DISW",
	"DISW_CORE",
	"RASW",
	"RASW_CORE",
	"RSSW",
	"RSSW_CORE",
	"RTSSW",
	"RTSSW_CORE",
	"RLSW",
	"SGDL",
	"ASQSW",
	"ASQSW_CORE",
]);

export const isPteAssessorAgentItem = (itemType?: OriginalItemTypes): boolean =>
	itemType != null && PTE_ASSESSOR_SUPPORTED_CODES.has(itemType);

export const isPteAssessorSpeakingItem = (
	itemType?: OriginalItemTypes,
): boolean => itemType != null && PTE_ASSESSOR_SPEAKING_CODES.has(itemType);
